import React, { FC } from 'react';
import { FiX } from 'react-icons/fi';

type Props = {
  closeToast?: () => void;
};

const CloseToastButton: FC<Props> = ({ closeToast }) => (
  <FiX onClick={closeToast} className="Toastify__toast-close" />
);

export default CloseToastButton;
